import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { sharedStyles } from '../../utils/Style';
import { useLocalizedText } from '../../hooks/useLocalizedText';

interface YoutubePreviewDialogProps {
  title?: string;
  videoID: string;
  open: boolean;
  onClose: () => void;
}

export const YoutubePreviewDialog = (props: YoutubePreviewDialogProps) => {
  const t = useLocalizedText();

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '690px',
          },
        },
      }}
    >
      <DialogTitle>
        {props.title ?? t('youtube_dialog.youtube_video')}
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: '56.25%', // 16:9 aspect ratio
          }}
        >
          <Box
            component='iframe'
            src={`https://www.youtube.com/embed/${props.videoID}`}
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: '0',
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
